import { TFunction } from 'i18next';

export interface QuotationRequestConfig {
  getLabel: (t: TFunction) => string;
  code: string;
  color: string;

  canCreateInvoice?: boolean;
  requiresUserAction: boolean;
}

export const quotationRequestConfig = {
  associated: {
    getLabel: (t: TFunction) => t('associated'),
    code: '0',
    color: '#08139D',
    requiresUserAction: false,
  },

  waitingResponse: {
    getLabel: (t: TFunction) => t('waiting-response'),
    code: '1',
    color: '#002233',
    requiresUserAction: true,
  },

  quoted: {
    code: '2',
    getLabel: (t: TFunction) => t('quoted'),
    color: '#00bb33',
    canCreateInvoice: true,
    requiresUserAction: false,
  },

  canceled: {
    getLabel: (t: TFunction) => t('canceled'),
    code: '9',
    color: '#aa1122',
    requiresUserAction: false,
  },
};

export const quotationRequestConfigByCode = Object.fromEntries(
  Object.values(quotationRequestConfig).map((config) => [config.code, config]),
) as Record<string, QuotationRequestConfig>;
